import React from 'react'
import ReactDOM from 'react-dom/client'
import { BpmKeyFinder } from './components/BpmKeyFinder'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BpmKeyFinder />
  </React.StrictMode>,
)
